import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView, View } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import { Modal } from "react-bootstrap";
import BankAccountBlacklistCreateViewModel from "viewModels/finance/bankAccountBlacklists/bankAccountBlacklistCreateViewModel";
import CreateView from "../../common/create";
import BankAccountBlacklistForm from "./bankAccountBlacklistForm";

const BankAccountBlacklistCreateView: ViewComponent<BankAccountBlacklistCreateViewModel> = observer(({ vm }) => (
  <Modal scrollable show={true} onHide={vm.onHide} centered>
    <Modal.Header closeButton>
      <Modal.Title>{vm.translate("create")}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <View vm={vm.alertsViewModel} useLifecycle={true} />
      <CreateView vm={vm} hideTitle={true} form={<BankAccountBlacklistForm vm={vm} />} />
    </Modal.Body>
  </Modal>
));

registerView(BankAccountBlacklistCreateView, BankAccountBlacklistCreateViewModel);
